import { render } from "./ImageZoomer.vue?vue&type=template&id=75129d31"
import script from "./ImageZoomer.vue?vue&type=script&lang=js"
export * from "./ImageZoomer.vue?vue&type=script&lang=js"

import "./ImageZoomer.vue?vue&type=style&index=0&id=75129d31&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__